import type { UserDetails } from 'types'
import submitHubspotForm from './hubspot'
import type { HubspotFormData } from './types'

export const submitPermissionedUIHubspotForm = ({
  formId,
  user,
  additionalFields,
}: {
  formId: string
  user: UserDetails | null
  additionalFields?: Record<string, string>
}) => {
  const hubspotFormData: HubspotFormData = [
    {
      name: 'firstname',
      value: user?.givenName || '',
    },
    {
      name: 'lastname',
      value: user?.familyName || '',
    },
    {
      name: 'email',
      value: user?.email || '',
    },
    {
      name: 'company',
      value: user?.organisation || '',
    },
  ]

  if (additionalFields) {
    Object.entries(additionalFields).forEach(([key, value]) => {
      hubspotFormData.push({ name: key, value: value })
    })
  }

  return submitHubspotForm({
    id: formId,
    data: hubspotFormData,
  })
}
